import PropTypes from 'prop-types';

import { companyKindLabel, coversAllCompanyKinds, defaultCompanyKinds } from '../../../utils/companyKinds';
import { vocabularyOptions } from '../../../utils/targetingLabels';

import { MultiSelect } from './MultiSelect';

const selectedCompanyKinds = (filters, vocabulary) => filters.companyKinds ?? defaultCompanyKinds(vocabulary);

/**
 * Collapsed-card summary of the kind selection, or null when every kind is kept.
 * @param {Object} filters - UI filter state
 * @param {Object|undefined} vocabulary
 * @returns {string|null}
 */
export const summarizeCompanyKinds = (filters, vocabulary) => {
	const selected = selectedCompanyKinds(filters, vocabulary);
	if (selected.length === 0 || coversAllCompanyKinds(selected)) return null;
	if (selected.length === 1) return `nur ${companyKindLabel(vocabulary, selected[0])}`;
	return `${selected.length} Firmenarten`;
};

/**
 * Which kinds of company a search keeps (operating company, general partner, holding).
 * Until the user picks, the selection shows the vocabulary's default for new searches.
 */
export const CompanyKindSelect = ({ filters, onFilterChange, vocabulary }) => {
	const selected = selectedCompanyKinds(filters, vocabulary);
	const toggle = (value) =>
		onFilterChange(
			'companyKinds',
			selected.includes(value) ? selected.filter((kind) => kind !== value) : [...selected, value],
		);

	return (
		<div>
			<label className="block text-xs text-bgBase-800 mb-1">Firmenart</label>
			<MultiSelect
				options={vocabularyOptions(vocabulary?.companyKinds)}
				selected={selected}
				onChange={toggle}
				placeholder="Alle Firmenarten"
			/>
		</div>
	);
};

CompanyKindSelect.propTypes = {
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	vocabulary: PropTypes.object,
};
